import type { FC } from 'react';
import { sizes } from '../../resources/tokens';

type ExpandableErrorDetailsProps = {
  additionalLines: string[];
};

/**
 * Displays additional error message lines in an expandable format.
 * Used when error messages have multiple lines that can be shown/hidden.
 */
export const ExpandableErrorDetails: FC<ExpandableErrorDetailsProps> = ({ additionalLines }) => (
  <div
    style={{
      marginTop: sizes.xsmallPx,
    }}
  >
    {additionalLines.map((line) => (
      <div key={line}>{line}</div>
    ))}
  </div>
);
